// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"123":"a2dd8050","364":"4d92aaca","367":"9f79a7c3","388":"92394a16","463":"a3238465","755":"7e74e207","801":"587c67b5"}[chunkId] + ".chunk.js";
};